import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

//Import tooltip
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

//import service
import farmerService from "../../services/farmer.service";

//Import module Modal
import Modal from "react-bootstrap/Modal";

import { Form, Row, FormControl, Col } from "react-bootstrap";

import authService from "../../services/auth.service";
const user = authService.getCurrentUser();

function ModalUpDateStatus(props) {
  const [clock, setClock] = useState("");
  const [_number, set_Number] = useState("");
  const [errors, setErrors] = useState({});
  const [statusRun, setStatusRun] = useState(false);
  const [count, setCount] = useState([]);

  const renderTooltipStop = (props) => (
    <Tooltip {...props}>คลิ๊กเพื่อหยุดระบบการทำงาน</Tooltip>
  );

  const findFormErrors = () => {
    const newErrors = {};

    // factoryCode errors
    if (!clock || clock === "") newErrors.clock = "กรุณาเลือกเวลาที่ต้องการ";

    // factoryName errors
    if (!_number || _number === "")
      newErrors._number = "กรุณากรอกจำนวนที่ต้องการ";

    return newErrors;
  };

  const setField = (e) => {
    if (e.target.name === "clock") {
      setErrors({
        ...errors,
        [e.target.name]: null,
      });
      setClock(e.target.value);
    } else if (e.target.name === "_number") {
      setErrors({
        ...errors,
        [e.target.name]: null,
      });
      set_Number(e.target.value);
    }
  };

  const handleSetTime = (e) => {
    e.preventDefault();
    const newErrors = findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      //   console.log(form);
      props.onsubmit({
        time: clock,
        number: _number,
        user_id: user.user.user_id,
      });
    }
  };

  useEffect(() => {
    if (props.show || props.status === true || props.status === false) {
      farmerService.getCornJobStatus().then((response) => {
        // alert(JSON.stringify(response.data));
        setStatusRun(response.data.status);
        setCount(response.data.result);
      });
    }
  }, [props.show, props.status]);

  const handleStop = () => {
    farmerService.stopCornJobStatus().then((response) => {
      setStatusRun(response.data.status);
    });
  };

  const handleClose = () => {
    props.setShow(false);
    setErrors({});
    setClock("");
    set_Number("");
  };

  return (
    <>
      <Modal size="lg" show={props.show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>สถานะการทำงานของระบบตรวจสอบการเสียชีวิต</Modal.Title>
        </Modal.Header>
        {/* {loadAlert ? <LoadingAlert /> : ""} */}
        <Modal.Body>
          {statusRun.status ? (
            <>
              <span style={{ color: "green" }}>
                {"ระบบกำลังทำงาน - เวลา " +
                  statusRun.time +
                  " นาฬิกาของทุกวัน " +
                  statusRun._number +
                  " คน"}
              </span>{" "}
              <OverlayTrigger placement="top" overlay={renderTooltipStop}>
                <i
                  onClick={handleStop}
                  className="bi bi-stop-circle"
                  style={{ color: "red" }}
                ></i>
              </OverlayTrigger>
            </>
          ) : (
            <span style={{ color: "red" }}>ระบบหยุดการทำงาน</span>
          )}
          <hr />
          {count.map((a, index) => {
            if (a.dopa_status_check === false) {
              return (
                <div key={index}>
                  <span style={{ color: "orange" }}>
                    *ยังไม่ได้อัพเดท = {a.status_number}
                  </span>
                  <br />
                </div>
              );
            } else {
              return (
                <div key={index}>
                  {" "}
                  <span style={{ color: "green" }}>
                    *อัพเดทแล้ว = {a.status_number}
                  </span>
                  <br />
                </div>
              );
            }
          })}
        </Modal.Body>
        <Modal.Footer style={{ display: "inline" }}>
          <Row>
            <Col md={4}>
              <Form.Label>เวลาของทุกวัน</Form.Label>
              <Form.Select
                size="sm"
                name="clock"
                value={clock}
                type="text"
                // onChange={handleSearchStatusChange}
                onChange={(e) => setField(e)}
                isInvalid={!!errors.clock}
              >
                <option value="">-- เลือกเวลา --</option>
                {[...Array.from(Array(24).keys(), (n) => n)].map(
                  (item, key) => (
                    <option key={key} value={item}>
                      {item}
                    </option>
                  )
                )}
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                {errors.clock}
              </Form.Control.Feedback>
            </Col>
            <Col md={3}>
              <Form.Label>จำนวนที่ต้องการอัพเดท</Form.Label>
              <FormControl
                size="sm"
                name="_number"
                value={_number}
                // onChange={handleSearchStatusChange}
                onChange={(e) => setField(e)}
                isInvalid={!!errors._number}
              ></FormControl>
              <Form.Control.Feedback type="invalid">
                {errors._number}
              </Form.Control.Feedback>
            </Col>
            <Col md={5} style={{ textAlign: "right" }}>
              <button className="btn btn-primary" onClick={handleSetTime}>
                ตั้งเวลา
              </button>
              {/* <button className="btn btn-warning" onClick={handleReset}>
                เคลียร์ค่า
              </button> */}
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ModalUpDateStatus;
ModalUpDateStatus.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  years: PropTypes.array,
  import: PropTypes.func,
  // delete: PropTypes.func,
  // setdata: PropTypes.func,
  onsubmit: PropTypes.func,
  status: PropTypes.bool,
};
